import { render, staticRenderFns } from "./ProductOptionsCard.vue?vue&type=template&id=d9ffb982&scoped=true&"
import script from "./ProductOptionsCard.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionsCard.vue?vue&type=style&index=0&id=d9ffb982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ffb982",
  null
  
)

export default component.exports